import * as Yup from 'yup';
import { sharedSchema } from '../shared/sharedSchema';

export const schema = Yup.object().shape({
    contraceptionMedicine: Yup.string().required('Pole wymagane').nullable(),
    dateOfLastMenstruation: Yup.string().required('Pole wymagane').nullable(),
    lastUnprotectedSex: Yup.string().required('Pole wymagane').nullable(),
    lastVisitToDoctor: Yup.string().required('Pole wymagane').nullable(),
    additionalDiseases: Yup.string().required('Pole wymagane').nullable(),
    importantInformation: Yup.string().required('Pole wymagane'),
    ...sharedSchema,
});
